export default __webpack_public_path__ + "static/media/4.07e71e5c.png";